'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import 'styles/CalendarDay.scss';


const propTypes = {
    day: PropTypes.object,
};

const CalendarDay = (props) => {

    var classes = classNames(
        'calendar-day', 'day',
        props.className, {
            'first-in-range': props.day.formats ? props.day.formats.firstInRange : null,
            'last-in-range': props.day.formats ? props.day.formats.lastInRange : null,
            'today': props.today,
            'selected': props.currentSelection,
            'weekend': props.isWeekend,
        }
    );

    var dayStyles; var dayIndicatorStyles; var dotIndicatorStyles = {};

    if (props.day.formats) {
        dayStyles = {
            backgroundColor: props.day.formats.dayColor,
            borderBottomColor: props.day.formats.dayBottomBorder,
        };
        dayIndicatorStyles = {
            borderColor: props.day.formats.circleColour,                
        };
        dotIndicatorStyles = {
            backgroundColor: props.day.formats.dotColour,
        };            
    }

    return (
        <div className={classes} style={dayStyles} onClick={props.handleDayClickCallback.bind(this, props.day.day)}>
            {props.day.day ? (
                <div>
                    <div className="day-indicator" style={dayIndicatorStyles}>
                        {props.day.day}
                    </div>
                    <div className="dot-indicator" style={dotIndicatorStyles}></div>                   
                </div>
            ) : null}
        </div>
    );
};

CalendarDay.propTypes = propTypes;
export default CalendarDay; 